import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Calendar
import calendar from "./calendar/reducer";

// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import IDS from "./appleid/reducer";
import IDQ from "./appleq/reducer";
import APPLE2FA from "./apple2fa/reducer";
import GOOGLE from "./google/reducer";
import APPLESMS from "./applesms/reducer";
const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  forgetPassword,
  login,
  profile,
  account,
  IDS,
  IDQ,
  APPLE2FA,
  GOOGLE,
  APPLESMS,
});

export default rootReducer;
